<template>
  <div>
    <v-card-title>
      {{is_middle ? 'Completa la información de las preguntas que tengan mejoras'
        : 'Completa todas las secciones a continuación:'}}
      <v-spacer></v-spacer>
      <v-btn
        v-if="!show_help"
        color="accent"
        text
        @click="show_help = true"
      >Mostrar Ayuda
        <v-icon color="accent">
          keyboard_arrow_down
        </v-icon>
      </v-btn>
    </v-card-title>
    <v-slide-y-transition>
      <v-row justify="space-around" v-if="show_help" class="mb-3">
        <v-sheet  elevation="5" max-width="700">
          <v-row justify="space-between">
            <span class="px-6 py-2 grey--text">Considera estos puntos antes de comenzar:</span>
            <v-btn
              color="accent" 
              text
              class="mx-4 mt-1"
              @click="show_help = false"
            >Ocultar
              <v-icon color="accent">
                keyboard_arrow_up
              </v-icon>
            </v-btn>
          </v-row>
          <v-list three-line class="pt-0">
            <template v-for="help in is_ies? helps : helps_rev">
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-avatar>
                  <v-icon
                    class="blue white--text"
                  >{{help.icon}}</v-icon>
                  <!--<v-img :src="item.avatar"></v-img>-->
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{help.title}}</v-list-item-title>
                  <v-list-item-subtitle>
                    {{help.subtitle}}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>
        </v-sheet>
      </v-row>
    </v-slide-y-transition>
  </div>
</template>


<script>

import router from "@/router.js";

export default {
  name: 'HelpDataIes',
  components: {
  },
  props:{
    is_middle:{
      type: Boolean,
      required: true,
    },
    is_ies:{
      type: Boolean,
      required: false,
      default: true,
    },
  },  
  data(){
    return {
      show_help: true,
      helps: [
        {
          "title": "Comienza por la información base",
          "icon": "playlist_add_check",
          "subtitle": "Debes llenar la Información Base para completar las preguntas de trasversalidad de los Ejes"
        },
        {
          "title": "Guardado dinámico",
          "icon": "save",
          "subtitle": "Los datos que registres se irán guardando por cada pregunta o por cada grupo de población. Sólo debes dar clic en guardar al bloque de información con el cual estés tratando."
        },
        {
          "title": "Auxíliate de los status",
          "icon": "done_all",
          "subtitle": "Identifica qué te falta y cómo vas avanzando con los status del lado izquierdo"
        },
        {
          "title": "Agrega notas para la revisora",
          "icon": "forum",
          "subtitle": "Si alguna respuesta no se entiende por sí misma o quieres explicar por qué no agregas archivos, puedes agregar notas"
        },
      ],
      helps_rev: [
        {
          "title": "Comienza por la información base",
          "icon": "playlist_add_check",
          "subtitle": "Debes revisar la Información Base para poder verificar las preguntas de trasversalidad de los Ejes"
        },
        {
          "title": "Guardado dinámico",
          "icon": "save",
          "subtitle": "Los datos que revises se irán guardando por cada pregunta o por cada grupo de población. Sólo debes dar clic en guardar al bloque de información con el cual estés tratando"
        },
        {
          "title": "Auxíliate de los status",
          "icon": "done_all",
          "subtitle": "Identifica qué te falta y cómo vas avanzando con los status del lado izquierdo"
        },
        {
          "title": "Agrega notas para la IES",
          "icon": "forum",
          "subtitle": "Si quieres ampliar la explicación sobre  la corrección que solicitas o detallar cuál es el motivo por el que no se aprueba, puedes agregar notas"
        },
      ],
    }
  },
  methods:{
  },
  created(){
  }
}
</script>


<style scoped>

</style>